import React from 'react';
import DropDown from 'js/common/components/DropDown';

class RTFControlItem extends React.Component {
    constructor() {
        super();

        this.state = {};
    };
  
    render() {
        let className = this.props.config.cls;

        if ( this.props.active ) {
            className += ' RTF_activeButton';
        }

        return (
            <React.Fragment>
                {
                    ( this.props.config.type === 'custom_drop_down' && 
                        <DropDown dropdowncfg={ this.props.config.dropDownCfg } key={ `${ this.props.config.key }_dropdown${ this.props.refreshDropdown ? '_refresh' : '' }` }
                            store={ this.props.store } onChange={ this._onToggle.bind(this) } /> ) ||
                        <span className={ `${ className } rtf_toolbar_item` } onMouseDown={ this._onToggle.bind(this) } title={ this.props.config.title } ></span>
                }
            </React.Fragment>
        );
    };

    /* istanbul ignore next */
    _onToggle( event, props ) {
        event.preventDefault();
        this.props.onToggle( this.props.config.type === 'custom_drop_down' ? event.currentTarget.getAttribute('value') : this.props.config.style, props );
    };
}

export default RTFControlItem;